module.exports = __webpack_public_path__ + "img/pp_service4.d669529b.png";